var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-modal',{attrs:{"id":_vm.id,"header-text-variant":_vm.headerTextVariant,"ok-only":true,"title":_vm.$t('modalReleaseNoteTitle') + ' v' + _vm.version + ' - ' + _vm.date,"size":"lg"},on:{"hide":_vm.hideReleaseModal}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.note)}})])
}
var staticRenderFns = []

export { render, staticRenderFns }